import styled, { css } from 'styled-components'
import { Form } from '@/ui'

export const IconContainer = styled.div`
  padding: 12px;
  border: 1px solid #e6e8eb;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  margin-right: 16px;
  justify-content: center;
`
export const Toggle = styled(Form.Checkbox).attrs({
  toggle: true,
  checkedColor: '#2A5EF6',
  uncheckedColor: '#E6E8EB',
})`
  &&&&& {
    width: 32px;
    height: 18px;
    float: right;
    input:checked ~ .box:after,
    input:checked ~ label:after {
      left: 15px;
    }
    label {
      ::before {
        width: 32px;
        height: 18px;
        background: #b7b7b7;
      }
      ::after {
        top: 1px;
        width: 16px;
        height: 16px;
        border: 0;
        box-shadow: none;
        background-color: #fff;
        left: 1px;
      }
    }
  }
`

export const Container = styled.div<{
  border?: 'top' | 'bottom' | 'both' | 'none'
  margin: string
}>`
  ${({ border, margin }) => css`
    padding: 40px 0;
    border-top: ${['top', 'both'].includes(border ?? '')
      ? '1px solid #F3F3F5'
      : 'none'};
    border-bottom: ${['bottom', 'both'].includes(border ?? '')
      ? '1px solid #F3F3F5'
      : 'none'};
    margin: ${margin};
  `}
`

export const ContentContainer = styled.div`
  width: 100%;
  background-color: rgba(42, 94, 246, 0.02);
  padding: 24px;
  border-radius: 6px;
  border: 1px solid rgba(42, 94, 246, 0.1);
  margin-top: 32px;
`
